import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import { renderPromotionMessage } from '../../services/utilityFunctions';
import translate from '../translate';

const PromoDateBox = ({ t, promotionPriceDateStart, promotionPriceDateEnd }) => {
  const currentDate = moment().utc().valueOf();
  const hasPromotionDate =
    (promotionPriceDateStart && !promotionPriceDateEnd) ||
    (promotionPriceDateStart && promotionPriceDateEnd && promotionPriceDateStart < promotionPriceDateEnd) ||
    (!promotionPriceDateStart && promotionPriceDateEnd && promotionPriceDateEnd > currentDate);

  return (
    <>
      {hasPromotionDate && (
        <div className="promo-container">
          <div className="promo-box">
            <span className="promo-text">
              {renderPromotionMessage(t, promotionPriceDateStart, promotionPriceDateEnd)}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

PromoDateBox.propTypes = {
  t: PropTypes.func.isRequired,
  promotionPriceDateStart: PropTypes.number,
  promotionPriceDateEnd: PropTypes.number,
};
PromoDateBox.defaultProps = {
  promotionPriceDateStart: null,
  promotionPriceDateEnd: null,
};

export default translate(PromoDateBox);
